var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"page-scroll",class:{'is-show': _vm.scroll > 0},on:{"click":_vm.pageScroll}},[_c('span',{staticClass:"page-scroll-icon"}),_c('span',{staticClass:"page-scroll-text"},[_vm._v("PageTOP")])])}
var staticRenderFns = []

export { render, staticRenderFns }